var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleSafeOne({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0005 15.7495C24.3832 15.7495 27.1255 13.0073 27.1255 9.62451C27.1255 6.24177 24.3832 3.49951 21.0005 3.49951C17.6177 3.49951 14.8755 6.24177 14.8755 9.62451C14.8755 13.0073 17.6177 15.7495 21.0005 15.7495Z",
    stroke: "#191919",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49951 35.8745C3.49951 28.1425 10.551 21.8745 19.2495 21.8745",
    stroke: "#191919",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4995 25.5505C24.4995 24.6171 30.6245 22.7505 30.6245 22.7505C30.6245 22.7505 36.7495 24.6171 36.7495 25.5505C36.7495 33.0171 30.6245 36.7505 30.6245 36.7505C30.6245 36.7505 24.4995 33.0171 24.4995 25.5505Z",
    stroke: "#191919",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleSafeOne);
export default __webpack_public_path__ + "static/media/people-safe-one.fef7ea612e23d40c87bf942d1c7350db.svg";
export { ForwardRef as ReactComponent };